import { useManageChatroomMembersMutation } from '@pba/react-chat-core';
import { useCallback, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { Icon, Modal, message } from 'ui';

type P = {
  chatroomId: string;
};

export const useRemoveChatMemberConfirmModal = ({ chatroomId }: P) => {
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: manageChatroomMembers } = useManageChatroomMembersMutation();

  const confirm = useCallback(
    ({ memberName, memberUserId }: { memberName: string; memberUserId: string }) => {
      modal.confirm({
        content: (
          <Trans
            components={{ strong: <strong /> }}
            i18nKey="Are you sure you want to remove <strong>{{memberName}}</strong> from this chat?"
            values={{ memberName }}
          />
        ),
        icon: <Icon color="error" icon="minus-circle-line" />,
        okText: 'Remove',
        async onOk() {
          await manageChatroomMembers(
            {
              chatroomId,
              membersToRemove: [{ _id: memberUserId }],
            },
            {
              onError() {
                message.error("Something went wrong. Member couldn't be removed.");
              },
              onSuccess() {
                message.success('Member removed successfully');
              },
            },
          );
        },
        title: 'Remove member',
        type: 'error',
      });
    },
    [chatroomId, manageChatroomMembers, modal],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
